<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange" :options="timeOptions" :value='searchConf.searchTime'
                          @on-change='timeChange' format="yyyy-MM-dd"
                          :placeholder="$t('选择时间')" style="width: 200px">
              </DatePicker>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->

    <!--    -->
  </div>
</template>
<script>
import {
  getList
} from '@/api/dataManage/totalReport'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('日期'),
        key: 'on_day',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('游戏人数'),
        key: 'gameUserNum',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('平台总盈亏'),
        key: 'ptTotalWin',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('每日任务'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('任务派奖') + ':' + params.row.tongjiDayGame.game_profit), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('任务返佣') + ':' + params.row.tongjiDayGame.game_fan),])

        }
      }, {
        title: this.$t('余额宝'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('利息派送') + ':' + params.row.tongjiDayGame.yeb_profit), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('转入') + ':' + params.row.tongjiDayGame.yeb_to_yeb),h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('转出') + ':' + params.row.tongjiDayGame.yeb_to_account)])

        }
      }, {
        title: this.$t('VIP'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP消费总额') + ':' + params.row.tongjiDayGame.game_buy_vip),h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP押金返还') + ':' + params.row.tongjiDayGame.game_back_vip), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP1次数') + ':' + params.row.tongjiDayGame.game_buy_vip1_user),h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP2次数') + ':' + params.row.tongjiDayGame.game_buy_vip2_user),h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP3次数') + ':' + params.row.tongjiDayGame.game_buy_vip3_user)])

        }
      },{
        title: this.$t('VIP'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP4次数') + ':' + params.row.tongjiDayGame.game_buy_vip4_user), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP5次数') + ':' + params.row.tongjiDayGame.game_buy_vip5_user),h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('VIP6次数') + ':' + params.row.tongjiDayGame.game_buy_vip6_user)])

        }
      }, {
        title: this.$t('充提情况'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('充值金额') + ':' + params.row.tongjiDayRecharge.all_recharge), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('提现金额') + ':' + params.row.tongjiDayWithdraw.all_withdraw),])
        }
      }, {
        title: this.$t('赠送礼金'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('活动赠送') + ':' + params.row.tongjiDaySend.huodong_send), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('充值赠送') + ':' + params.row.tongjiDaySend.recharge_send), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('人工赠送') + ':' + params.row.tongjiDaySend.rengong_send),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('dataManage/totalReport/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('dataManage/totalReport/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('dataManage/totalReport/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
  }
}
</script>
